/* generated using openapi-typescript-codegen -- do no edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { CioxRequestCreateDTO } from '../models/CioxRequestCreateDTO'
import type { CioxRequestDTO } from '../models/CioxRequestDTO'
import type { CioxRequestUpdateDTO } from '../models/CioxRequestUpdateDTO'
import type { PaginatedDTO_CioxRequestDTO_ } from '../models/PaginatedDTO_CioxRequestDTO_'
import type { CancelablePromise } from '../core/CancelablePromise'
import { OpenAPI } from '../core/OpenAPI'
import { request as __request } from '../core/request'
export class AspenCioxRequestsService {
    /**
     * Index
     * Get paginated list of ciox requests, optionally scoped to one patient.
     * @returns PaginatedDTO_CioxRequestDTO_ Successful Response
     * @throws ApiError
     */
    public static indexCioxRequestsGet({
        page = 1,
        limit = 10,
        patientId
    }: {
        page?: number
        limit?: number
        patientId?: string | null
    }): CancelablePromise<PaginatedDTO_CioxRequestDTO_> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/aspen/ciox-requests',
            query: {
                page: page,
                limit: limit,
                patient_id: patientId
            },
            errors: {
                422: `Validation Error`
            }
        })
    }
    /**
     * Create
     * Create a new ciox request.
     * @returns CioxRequestDTO Successful Response
     * @throws ApiError
     */
    public static createCioxRequestsPost({ requestBody }: { requestBody: CioxRequestCreateDTO }): CancelablePromise<CioxRequestDTO> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/aspen/ciox-requests',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                422: `Validation Error`
            }
        })
    }
    /**
     * Get
     * Get a specific ciox request by ID.
     * @returns CioxRequestDTO Successful Response
     * @throws ApiError
     */
    public static getCioxRequestsCioxRequestIdGet({ cioxRequestId }: { cioxRequestId: string }): CancelablePromise<CioxRequestDTO> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/aspen/ciox-requests/{ciox_request_id}',
            path: {
                ciox_request_id: cioxRequestId
            },
            errors: {
                422: `Validation Error`
            }
        })
    }
    /**
     * Update
     * Update a ciox request.
     * Automatically logs all field changes to the audit trail.
     * @returns CioxRequestDTO Successful Response
     * @throws ApiError
     */
    public static updateCioxRequestsCioxRequestIdPatch({
        cioxRequestId,
        requestBody
    }: {
        cioxRequestId: string
        requestBody: CioxRequestUpdateDTO
    }): CancelablePromise<CioxRequestDTO> {
        return __request(OpenAPI, {
            method: 'PATCH',
            url: '/aspen/ciox-requests/{ciox_request_id}',
            path: {
                ciox_request_id: cioxRequestId
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                422: `Validation Error`
            }
        })
    }
    /**
     * Delete
     * Delete a ciox request.
     * Automatically logs deletion to the audit trail.
     * @returns string Successful Response
     * @throws ApiError
     */
    public static deleteCioxRequestsCioxRequestIdDelete({ cioxRequestId }: { cioxRequestId: string }): CancelablePromise<Record<string, string>> {
        return __request(OpenAPI, {
            method: 'DELETE',
            url: '/aspen/ciox-requests/{ciox_request_id}',
            path: {
                ciox_request_id: cioxRequestId
            },
            errors: {
                422: `Validation Error`
            }
        })
    }
}
